import React from 'react';
import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { enumToOptions } from '../../utils/EnumUtils';

type Option = { value: number | ''; text: string };

interface EnumFilterCellProps<TEnum extends object> extends GridCustomFilterCellProps {
    enumType: TEnum;
    getText?: (value: number, name: string) => string;
    defaultText?: string; // e.g. "All statuses"
}

export const EnumFilterCell = <TEnum extends object,>(
    props: EnumFilterCellProps<TEnum>
) => {
    const { value, onChange, title, enumType, getText, defaultText = 'All' } = props;

    const defaultOption: Option = { value: '', text: defaultText };

    const options: Option[] = [
        ...enumToOptions(enumType, getText)
    ];

    const hasValue = (v: any) => v !== '' && v !== undefined && v !== null;

    const currentOption: Option =
        hasValue(value)
            ? (options.find(o => o.value === value) ?? defaultOption)
            : defaultOption;

    const handleChange = (e: DropDownListChangeEvent) => {
        const selected = (e.value as Option).value;
        const nextHasValue = hasValue(selected);

        onChange({
            value: nextHasValue ? selected : '',
            operator: nextHasValue ? 'eq' : '',
            syntheticEvent: e.syntheticEvent
        });
    };

    return (
        <div className="k-filtercell" title={title}>
            <DropDownList
                data={options}
                dataItemKey="value"
                textField="text"
                value={currentOption}
                defaultItem={defaultOption}
                onChange={handleChange}
            />
        </div>
    );
};